import React, { useEffect } from 'react'
import AdminDashboardLayout from './AdminDashboardLayout'
import { useParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { base } from '../../constants/base'
import { corporateShowSingleEmployeesAPI } from '../../redux/slices/CorporateAddEmployee'
import './ProfileViewPage.css'

const EmployeeViewPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loading = useSelector(state => state.coporateAddEmployeSlice.employeeLoading);
    const singleEmployee = useSelector(state => state.coporateAddEmployeSlice.singleUserDetial);
    const param = useParams();
    const employee_id = param?.id;
    const corporate_id = param?.parent_id;

    const fetchSingleEmployee = async () => {
        const user = {
            id: corporate_id
        }
        await dispatch(corporateShowSingleEmployeesAPI({ user, employee_id }));
    }

    useEffect(() => {
        fetchSingleEmployee();
    }, [corporate_id, employee_id]);

    const getStatusClass = (status) => {
        switch (status?.toLowerCase()) {
            case 'active':
                return 'status-active';
            case 'block':
            case 'blocked':
                return 'status-blocked';
            default:
                return 'status-pending';
        }
    };

    return (
        <AdminDashboardLayout>
            <div className="profile-view-page">
                {/* Page Header */}
                <div className="pv-header">
                    <button className="pv-back-btn" onClick={() => navigate(`/admin/employees/${corporate_id}`)}>
                        <i className="fas fa-arrow-left"></i>
                        <span>Back to Employees</span>
                    </button>
                    <h1 className="pv-title">Employee Details</h1>
                </div>

                {loading ? (
                    <div className="pv-loading">
                        <div className="pv-loader"></div>
                    </div>
                ) : (
                    <div className="pv-content">
                        {/* Profile Card */}
                        <div className="pv-profile-card">
                            <div className="pv-profile-header">
                                <div className="pv-avatar-section">
                                    {singleEmployee?.images?.[0]?.path ? (
                                        <img
                                            src={`${base.imageUrl}${singleEmployee?.images?.[0]?.path}`}
                                            alt={singleEmployee?.name}
                                            className="pv-avatar"
                                        />
                                    ) : (
                                        <div className="pv-avatar-placeholder">
                                            <i className="fas fa-user"></i>
                                        </div>
                                    )}
                                </div>
                                <div className="pv-profile-info">
                                    <h2 className="pv-name">{singleEmployee?.name || '-'}</h2>
                                    <p className="pv-email">{singleEmployee?.email || '-'}</p>
                                    <div className="pv-badges">
                                        <span className="pv-role-badge">Employee</span>
                                        {singleEmployee?.status && (
                                            <span className={`pv-status-badge ${getStatusClass(singleEmployee?.status)}`}>
                                                {singleEmployee?.status}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Details Grid */}
                        <div className="pv-details-grid">
                            {/* Contact Information */}
                            <div className="pv-details-card">
                                <div className="pv-card-header">
                                    <i className="fas fa-address-book"></i>
                                    <h3>Contact Information</h3>
                                </div>
                                <div className="pv-card-body">
                                    {singleEmployee?.phone_no && (
                                        <div className="pv-info-row">
                                            <div className="pv-info-icon">
                                                <i className="fas fa-phone"></i>
                                            </div>
                                            <div className="pv-info-content">
                                                <span className="pv-info-label">Phone Number</span>
                                                <span className="pv-info-value">{singleEmployee?.phone_no}</span>
                                            </div>
                                        </div>
                                    )}
                                    {singleEmployee?.address?.address && (
                                        <div className="pv-info-row">
                                            <div className="pv-info-icon">
                                                <i className="fas fa-location-dot"></i>
                                            </div>
                                            <div className="pv-info-content">
                                                <span className="pv-info-label">Address</span>
                                                <span className="pv-info-value">{singleEmployee?.address?.address}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Identification */}
                            <div className="pv-details-card">
                                <div className="pv-card-header">
                                    <i className="fas fa-id-card"></i>
                                    <h3>Identification</h3>
                                </div>
                                <div className="pv-card-body">
                                    {singleEmployee?.ss_number && (
                                        <div className="pv-info-row">
                                            <div className="pv-info-icon">
                                                <i className="fas fa-address-card"></i>
                                            </div>
                                            <div className="pv-info-content">
                                                <span className="pv-info-label">Social Security Number</span>
                                                <span className="pv-info-value">{singleEmployee?.ss_number}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* About */}
                            {singleEmployee?.about && (
                                <div className="pv-details-card pv-full-width">
                                    <div className="pv-card-header">
                                        <i className="fas fa-info-circle"></i>
                                        <h3>About</h3>
                                    </div>
                                    <div className="pv-card-body">
                                        <p className="pv-about-text">{singleEmployee?.about}</p>
                                    </div>
                                </div>
                            )}

                            {/* Services */}
                            {singleEmployee?.services?.length > 0 && (
                                <div className="pv-details-card pv-full-width">
                                    <div className="pv-card-header">
                                        <i className="fas fa-briefcase"></i>
                                        <h3>Services</h3>
                                    </div>
                                    <div className="pv-card-body">
                                        <div className="pv-services-list">
                                            {singleEmployee?.services?.map((item, index) => (
                                                <div key={index} className="pv-service-item">
                                                    <div className="pv-service-icon">
                                                        <i className="fas fa-check"></i>
                                                    </div>
                                                    <div className="pv-service-info">
                                                        <span className="pv-service-name">{item?.name}</span>
                                                        <span className="pv-service-price">
                                                            {item?.currency === 'USD' ? '$' : item?.currency === 'POUND' ? '£' : '₨'}
                                                            {item?.price}
                                                        </span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </AdminDashboardLayout>
    )
}

export default EmployeeViewPage
